import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function RequireAuth({ children, roles }) {
  const { user, sessionState, loading } = useAuth();
  const loc = useLocation();

  if (loading) return <div className="apwo-auth-shell"><div className="apwo-auth-card" style={{ padding: 32 }}>Loading…</div></div>;
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname }} />;

  // Force MFA/pw-change gating first
  if (sessionState === "AWAITING_MFA") return <Navigate to="/mfa" replace />;
  if (sessionState === "AWAITING_PW_CHANGE") return <Navigate to="/change-password" replace />;

  if (roles && roles.length > 0 && !roles.includes(user.role)) {
    return <Navigate to={user.role === "OWNER_ADMIN" ? "/admin" : "/portal"} replace />;
  }
  return children;
}
